import { BridgeComponent } from '@hotwired/hotwire-native-bridge';

type HapticStyle = 'light' | 'success';

/**
 * Plays a haptic tap when the element appears. Does nothing in a browser or in builds that do not register the
 * component. Attach it with data-controller="bridge--haptic" and choose data-bridge--haptic-style-value:
 * "light" (default) for a small tap, "success" for the confirmation pattern.
 */
export default class HapticController extends BridgeComponent {
  public static component = 'haptic';
  public static values = { style: { type: String, default: 'light' } };
  declare private readonly styleValue: HapticStyle;

  public connect(): void {
    super.connect();
    this.send('play', { style: this.styleValue });
  }
}
